// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-category-view{font-family:Arial,Helvetica,\"sans-serif\"}.home-category-view .video-img{width:100%;padding:.3125rem 0 .3125rem 0}.home-category-view .video-label{font-family:Arial,Helvetica,\"sans-serif\"}.home-category-view .video-hr{margin:.3125rem .3125rem .0625rem .3125rem}", ""]);
// Exports
module.exports = exports;
